import * as React from 'react';
import {connect} from 'react-redux';

// @ts-expect-error
import decapitalize from 'underscore.string/decapitalize';

import {GAP_SELECT_VALUES_DAY_TO_YEAR} from '../../../reports/report-constants';
import {ReportSummary} from '../../../reports/report-summary';
import type {
    CustomLeadStats,
    ForecastStats,
    ActivityStats,
    SiteAnalyticsStats,
} from '../../../reports/report-summary';
import type {ChartReportParams} from '../../../reports/report-types';

import type {NutshellState} from '../../../../store';

import * as analyticsReportSelectors from './analytics-selectors';

type OwnProps = {
    currentGapIndex: number;
    reportParams: ChartReportParams;
};

type StateProps = {
    chartBucketWithValuesCount: number;
    summaryStats: CustomLeadStats | ForecastStats | ActivityStats | SiteAnalyticsStats;
    isSummaryStatsLoading: boolean;
};

type Props = OwnProps & StateProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        chartBucketWithValuesCount:
            analyticsReportSelectors.getCurrentReportChartBucketWithValuesCount(state),
        summaryStats: analyticsReportSelectors.getSummaryStatsStats(state),
        isSummaryStatsLoading: analyticsReportSelectors.getSummaryStatsIsLoading(state),
    };
}
/*
 * This provides a set of rolled-up summary data for our reports.
 * For leads, we'll include information like total value, average time open,
 * average lead value, etc.
 *
 * For activities, we include information like total activities, total duration,
 * avg duration, etc.
 */
export function AnalyticsReportDataSummaryComponent(props: Props) {
    const {
        chartBucketWithValuesCount,
        currentGapIndex,
        isSummaryStatsLoading,
        reportParams,
        summaryStats,
    } = props;

    return (
        <ReportSummary
            summaryType='siteAnalytics'
            stats={summaryStats}
            facet={reportParams.facet}
            // @ts-expect-error
            gapLabel={decapitalize(GAP_SELECT_VALUES_DAY_TO_YEAR[currentGapIndex].label)}
            chartBucketCount={chartBucketWithValuesCount}
            isLoading={isSummaryStatsLoading}
        />
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const AnalyticsReportDataSummary = connector(AnalyticsReportDataSummaryComponent);
